import React from "react";
import RightworkSelect from "../shared/RightworkSelect";

export default function RequestLocationField({ location }) {
  const id = React.useId();
  if (!location.enabled) return null;
  const name = location.locations.find((store) => store.id === location.storeId)?.store_name;
  return (
    <div className="mb-5">
      {location.locations.length > 1 ? (
        <>
          <label id={`${id}-label`} htmlFor={id} className="block text-sm font-medium text-slate-700 mb-2">Send to location</label>
          <RightworkSelect id={id} value={location.storeId ?? ""}
            onChange={(event) => location.setStoreId(event.target.value)}
            options={location.locations.map((store) => ({ value: store.id, label: store.store_name }))}
            describedBy={`${id}-help`} error={!!location.error} />
        </>
      ) : name ? <p className="text-sm text-slate-700">Send to {name}</p> : null}
      <p id={`${id}-help`} className="mt-2 text-sm text-slate-500">
        {location.loading ? "Loading location settings…" : `This request will be sent to ${name || "the selected location"} for review.`}
      </p>
      {location.error && <div role="alert" className="mt-2 text-sm text-rose-700">
        {location.error} <button type="button" className="underline" onClick={location.retry}>Try again</button>
      </div>}
    </div>
  );
}
